import React from 'react';
import { useGrowthBook } from '@growthbook/growthbook-react';
import { NEW_HEADER_FLAG } from 'constants/feature-flags';
import { RouteName } from 'components/dynamic-page/route-matchers';
import type { TenantNavigationConfig } from '@tenants/types';
import dynamic from 'next/dynamic';

const LegacyHeader = dynamic(() => import('./legacy-header'), {
  loading: () => <></>,
  ssr: true,
});

const NewHeader = dynamic(() => import('./new-header'), {
  loading: () => <></>,
  ssr: true,
});

type ZooHeaderProps = {
  routeName?: RouteName;
  navConfig?: TenantNavigationConfig;
  useLightTheme?: boolean;
};

export type PanelItem = {
  id: string;
  label: string;
  link?: string;
  isEmber?: boolean;
  nested?: PanelItem[];
};

const ZooHeader = ({ routeName, navConfig, useLightTheme }: ZooHeaderProps) => {
  const growthbook = useGrowthBook();
  
  const isNewHeaderEnabled = growthbook.getFeatureValue(NEW_HEADER_FLAG, false);
  
  if (isNewHeaderEnabled) {
    return <NewHeader routeName={routeName} navConfig={navConfig} useLightTheme={useLightTheme} />;
  }
  
  return <LegacyHeader routeName={routeName} useLightTheme={useLightTheme} />;
};

export default ZooHeader;
